import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 20px 0;
`;

export const FormBody = styled.div`
  padding: 0 8px;
`;

export const FormInput = styled.input`
  background: #ebebeb;
  border: 1px solid #e0e0e0;
  width: 100%;
  height: 40px;
`;

export const FormTextarea = styled.textarea`
  background: #ebebeb;
  border: 1px solid #e0e0e0;
  width: 100%;
`;

export const Section = styled.div`
  margin-bottom: 30px;
  & > p {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: var(--primary-black-color);
    margin-bottom: 10px;
  }
`;
